import React, { useMemo } from "react";
import { useAppearance } from "../context/appearance";

interface Props {
  className?: string;
}

const Molecule: React.FC<Props> = (props) => {
  const { isDark } = useAppearance();

  const fillColor = useMemo(() => (isDark ? "#8B5CF6" : "#E5D1FA"), [isDark]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="743"
      height="940"
      viewBox="0 0 743 940"
      aria-hidden="true"
      {...props}
    >
      <g opacity="0.1">
        <path
          d="M236.439 128.828L625.3 84.2954C631.003 83.6426 636.596 86.0409 640.053 90.6222L875.842 403.032C879.347 407.67 880.085 413.832 877.801 419.157L737.485 746.354C735.201 751.679 730.228 755.392 724.452 756.05L335.591 800.583C332.739 800.909 329.931 800.479 327.372 799.382C324.814 798.285 322.566 796.547 320.837 794.255L85.0483 481.845C81.5436 477.208 80.8053 471.046 83.0889 465.721L223.406 138.523C225.691 133.199 230.664 129.486 236.439 128.828ZM116.536 469.851L341.1 767.375L711.439 724.972L844.358 415.026L619.794 117.502L249.454 159.907L116.536 469.851V469.851Z"
          fill={fillColor}
        />
        <path
          d="M711.46 731.337L845.099 419.71L847.491 414.133L625.905 111.94L247.939 157.018L114 469.343L343.677 770.053L711.46 731.337Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default Molecule;
